import {Component} from 'react';
import Stats from '../../../../vendor/stats';
import { position as positionPropType } from '../../../../prop-types/sizeMe';

/* React wrapper for Threejs framerate counter library */

class StatsComponent extends Component{
  constructor(props){
    super(props);
    this.stats = new Stats();
    this.doUpdate = true;
  }

  componentDidMount(){
    this.update.call(this);
  }

  componentWillUnmount(){
    this.doUpdate = false;
    document.body.removeChild(this.stats.domElement);
  }

  update(){
    this.stats.update();
    if(this.doUpdate){
      requestAnimationFrame(() => this.update());
    }
  }

  render(){
    const {position} = this.props
    this.stats.domElement.style.top = `${position.top + 90}px`;
    this.stats.domElement.style.left= `${position.left + 10}px`;

    document.body.appendChild(this.stats.domElement);
    return false;
  }
}

StatsComponent.propTypes = {
  position: positionPropType.isRequired
}

StatsComponent.displayName = 'Stats';

export default StatsComponent;



// WEBPACK FOOTER //
// ./src/components/StackupDesign/Viewer/StackupEditor/Stats.js